<template>
    <div id="organizationStructure">
        <div class="orgLeft" :style="myAutoContent">
            <el-container style="height:100%;width:100%">
                <el-header style="height:auto;margin-top:14px;margin-bottom:1px">
                    <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText"></el-input>
                </el-header>
                <el-main style="height:100%;width:100%;">
                    <el-tree :props="defaultProps" node-key="id" :load="loadNode" lazy accordion :expand-on-click-node="false" ref="tree2" @node-click="handleNodeClick" :filter-node-method="filterNode" :default-expanded-keys="showKeyArray" :highlight-current="true" class="treeClass">
                        <span class="custom-tree-node" slot-scope="{ node, data }">
                            <span v-if="data.level==0">
                                <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                            </span>
                            <span v-else-if="data.level==1">
                                <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                            </span>
                            <span v-else>
                                <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                            </span>
                        </span>
                    </el-tree>
                </el-main>
            </el-container>
        </div>

        <div class="orgRight" :style="myAutoContent">
            <!-- 操作栏 -->
            <div class="commonSearch" ref="commonSearchRef">
                <el-form class="el-form el-form--inline" onsubmit="return false">
                    <el-form-item>
                        <el-button type="primary" plain icon="el-icon-edit" @click="openEditDlg('','')">新增</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="danger" plain icon="el-icon-delete" @click="deleteData">删除</el-button>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" plain @click="openAuthorizeForAllDlg">批量角色授权</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" plain @click="batchEnableUserStatus('0')">启用</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" plain @click="batchEnableUserStatus('1')">禁用</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" plain @click="updaeregion()">设置校区</el-button>
                    </el-form-item>

                    <el-form-item class="head-right">
                        <el-button type="info" plain icon="el-icon-search" @click="initDataBySearch">查询</el-button>
                    </el-form-item>
                    <el-form-item class="head-right">
                        <el-input v-model.trim="select_word" placeholder="输入姓名/手机号" clearable></el-input>
                    </el-form-item>
                    <div style="clear:both"></div>
                </el-form>
            </div>

            <div class="myTable">
                <el-table :data="nextChildrenData" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange" @select="handleSelect" @select-all="handleSelection" v-loading="loading" element-loading-text="拼命加载中" size="medium" :height="myTabHeight">
                    <el-table-column type="selection" width="45" @selection-change="handleSelectionChange" :selectable="checkSelectTable"></el-table-column>
                    <el-table-column prop="userName" label="登录帐号" min-width="120"></el-table-column>
                    <el-table-column prop="realName" label="姓名" min-width="120"></el-table-column>
                    <el-table-column prop="mobile" label="手机号" min-width="150"></el-table-column>
                    <el-table-column prop="disabled" label="用户状态" min-width="80">
                        <template slot-scope="scope">
                            <span v-if="scope.row.disabled=='0'">
                                <span style="color:green">正常</span>
                            </span>
                            <span v-if="scope.row.disabled=='1'">
                                <span style="color:red">禁用</span>
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="roleNames" label="角色" min-width="150"> </el-table-column>
                    <el-table-column prop="huregionname" label="校区" min-width="100"> </el-table-column>

                    <el-table-column label="操作" width="100">
                        <template slot-scope="scope">
                            <span style="cursor:pointer" type="primary" class="fa fa-edit fa-2x btnColor" @click="openEditDlg(scope.$index, scope.row)" title="编辑"></span>
                            <span style="margin-left:10px;cursor:pointer" class="fa fa-user fa-2x btnColor" @click="openAuthorizeDlg(scope.$index,scope.row)" title="授权"></span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <!-- 分页框 -->
        <div class="commonPage">
            <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="cur_page" :page-sizes="[5, 10, 15, 30]" layout="total, sizes, prev, pager, next, jumper" :total="totalCount" :disabled="loading"></el-pagination>
        </div>

        <div>
            <EditDlg v-if="editDlgShow" ref="editDlgRef"></EditDlg>
            <AuthorizeDlg v-if="authorizeDlgShow" ref="authorizeDlgRef"></AuthorizeDlg>
            <AuthorizeForAllDlg v-if="authorizeForAllDlgShow" ref="authorizeForAllDlgRef"></AuthorizeForAllDlg>
            <Setarea v-if="SetareaShow" ref="SetareaRef"></Setarea>
        </div>
    </div>
</template>

<script>
let id = 1000;
import EditDlg from "./StaffManageEditDlg.vue";
import AuthorizeDlg from "./StaffManageAuthorizeDlg.vue";
import AuthorizeForAllDlg from "./StaffManageAuthorizeForAllDlg.vue";
import TabResize from "@/utils/TabResizeEx.js";
import Utils from "@/utils/Utils.js";
import SettingApi from "@/api/setting.js";
import _ from "lodash";
import Setarea from "./SetArea.vue";

export default {
    mixins: [TabResize],
    components: {
        EditDlg,
        AuthorizeDlg,
        AuthorizeForAllDlg,
        Setarea
    },
    mounted: function () {
        this.$nextTick(() => {
            this.loading = false;
            this.myAutoContent.height = this.myAutoContentHeight + "px";
            this.myTabHeight = this.myAutoContentInnerHeight + "px";
        });
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure addEventListener  resize ---");
        }
        window.addEventListener("resize", this.$mainResize);
    },

    computed: {
        myAutoContentHeight () {
            return this.getMyAutoContentHeight();
        },
        myAutoContentInnerHeight () {
            return this.getMyAutoContentInnerHeight();
        },
        $mainResize () {
            return _.debounce(() => {
                if (this.myAutoContent.height) {
                    this.myAutoContent.height = this.getMyAutoContentHeight() + "px";
                    this.myTabHeight = this.getMyAutoContentInnerHeight() + "px";
                } else {
                    if (this.$constant.DEV_MODE) {
                        console.log(" this.myAutoContentHeight 不存在");
                    }
                }
            }, 400);
        }
    },
    deactivated () {
        if (this.$constant.DEV_MODE) {
            console.log("-- OrganizationStructure removeEventListener  resize ---");
        }
        window.removeEventListener("resize", this.$mainResize);
    },

    data () {
        return {
            myAutoContent: {
                height: "600px",
                "overflow-y": "auto"
            },
            cascade: false,
            userStatus: [],
            workStatus: "",
            userLimit: "",
            overAllLevel: "",
            currentNode: null,
            SetareaShow: false,
            currentNodeType: 0,
            currentNodeId: 0,
            myTabHeight: 400,
            defaultProps: {
                children: "subs",
                label: "name",
                isLeaf: "leaf"
            },
            cacheData: {},
            filterText: "",
            editDlgShow: false,
            authorizeDlgShow: false,
            authorizeForAllDlgShow: false,
            loading: true,
            showKeyArray: [],
            nextChildrenData: [],
            listGroup: [], //完整组织架构
            listGroupBranchOrDept: [], //完整组织架构
            cur_page: 1,
            multipleSelection: [],
            select_word: "",
            parentId: "",
            timeFlag: false,
            totalCount: 0,
            staffCount: 0,
            per_page: this.$constant.PAGE_SIZE
        };
    },
    watch: {
        filterText (val) {
            this.$refs.tree2.filter(val);
        }
    },
    methods: {
        getMyAutoContentHeight () {
            let defTagsHeight = this.$constant.DEF_TAGS_HEIGHT;
            let defSearchHeight = 0;
            let defHomeHeight = 600;

            if (this.$refs.commonSearchRef) {
                defSearchHeight = this.$refs.commonSearchRef.clientHeight;
            }
            if (this.$parent.$refs.myHomeTagsRef && this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef) {
                defTagsHeight = this.$parent.$refs.myHomeTagsRef.$refs.myTagsRef.clientHeight;
            }
            defHomeHeight = window.innerHeight - this.$constant.DEF_HEADER_HEIGHT - defTagsHeight - this.$constant.DEF_PADDING_HEIGHT - defSearchHeight;
            return defHomeHeight;
        },
        getMyAutoContentInnerHeight () {
            let autoContentHeight = this.getMyAutoContentHeight();
            let defHomeHeight = 400;
            let defOperHeight = 47;
            if (this.$refs.commonOperBtnRef) {
                defOperHeight = this.$refs.commonOperBtnRef.clientHeight;
            }
            defHomeHeight = autoContentHeight - defOperHeight;
            return defHomeHeight;
        },
        filterNode (value, data) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        },

        initUserStatus () {
            let param = {
                parentCode: this.$constant.DICT_USER_STATUS
            };
            SettingApi.getClass()
                .initUserStatus(param)
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        this.userStatus = [];
                        let obj = { value: "", label: "全部" };
                        this.userStatus = [];
                        this.userStatus.push(obj);
                        for (let i = 0; i < data.length; i++) {
                            obj = {
                                value: data[i].code,
                                label: data[i].name
                            };
                            this.userStatus.push(obj);
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    return false;
                });
        },

        onloadGroup (node, resolve) {
            SettingApi.getClass()
                .onloadOrgGroup()
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        let data = resp.data.data;
                        this.listGroup = data;
                        if (resolve) {
                            resolve(this.listGroup);
                        }
                        this.showKeyArray = [];
                        this.showKeyArray.push(data[0].id);
                        //点击左边树之后this.parentId才会有值
                        if (!!this.parentId) {
                            this.$nextTick(() => {
                                this.$refs.tree2.setCurrentKey(this.parentId);
                            });
                        } else {
                            this.overAllLevel = data[0].level;
                            this.parentId = data[0].id;
                            this.parentName = data[0].name;
                            this.currentNodeType = data[0].type;
                            this.currentNodeId = data[0].id;
                            this.$nextTick(() => {
                                this.$refs.tree2.setCurrentKey(data[0].id);
                            });
                            if (this.timeFlag == false) {
                                this.timeFlag = true;
                                this.getListData(data[0].id);
                                this.initUserStatus();
                            }
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        resolve([]);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    resolve([]);
                    return false;
                });
        },

        updaeregion () {
            if (this.multipleSelection.length == 0) {
                this.$message.error("请选择一个员工！");
                return false;
            }
            if (this.multipleSelection.length == 1) {
                this.SetareaShow = true;
                this.$nextTick(() => {
                    this.$refs.SetareaRef.init(this.multipleSelection[0], this.parentId);
                });
            }
            if (this.multipleSelection.length == 2) {
                console.log(this.multipleTable);
                this.$message.error("只能选择一个员工！");
                return false;
            }
            if (this.multipleSelection.length > 2) {
                console.log(this.multipleTable);
                this.$message.error("只能选择一个员工！");
                return false;
            }
        },

        onloadGroupNextChild (type, id, resolve) {
            SettingApi.getClass()
                .onloadStaffGroupNextChild(id)
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.listGroupBranchOrDept = resp.data.data;
                        if (resolve) {
                            resolve(this.listGroupBranchOrDept);
                        }
                    } else {
                        this.$message.error(resp.data.msg);
                        resolve([]);
                        return false;
                    }
                }).catch(err => {
                    this.$message.error(err);
                    resolve([]);
                    return false;
                });
        },
        changeSender () {
            this.cur_page = 1;
            this.getListData(this.parentId);
        },

        getListData (id) {
            this.loading = true;
            let param = {
                id: id,
                pageNum: this.cur_page,
                pageSize: this.per_page,
                keyword: this.select_word,
                workStatus: this.workStatus,
                cascade: this.cascade
            };
            SettingApi.getClass()
                .getStaffListData(param)
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.totalCount = resp.data.data.totalElements;
                        this.nextChildrenData = resp.data.data.data;
                        this.initSelect();
                        this.loading = false;
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        loadNode (node, resolve) {
            //初始化组织架构数据
            if (node.level === 0) {
                this.onloadGroup(node, resolve);
                return;
            }
            if (node.level === 1) {
                this.currentNode = node;
            }
            setTimeout(() => {
                this.onloadGroupNextChild(node.data.type, node.data.id, resolve);
            }, 500);
        },

        handleNodeClick (data, node, vuecomponent) {
            this.parentId = data.id;
            this.parentName = data.name;
            this.overAllLevel = data.level;
            this.getListData(data.id);
        },

        //获取选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        handleSelect (selection, row) {
            this.cacheData[this.cur_page] = selection;
        },
        handleSelection (selection) {
            this.cacheData[this.cur_page] = selection;
        },

        initSelect () {
            for (let prop in this.cacheData) {
                if (prop == this.cur_page) {
                    if (this.cacheData[prop] && this.cacheData[prop].length > 0) {
                        this.$nextTick(() => {
                            this.checkIsSelected(this.cacheData[prop]);
                        });
                    }
                }
            }
        },

        checkIsSelected (selectedData) {
            this.nextChildrenData.forEach(element => {
                selectedData.forEach(el => {
                    if (el.id == element.id) {
                        this.$refs.multipleTable.toggleRowSelection(element, true);
                    }
                });
            });
        },

        openEditDlg (index, row) {
            this.editDlgShow = true;
            let operateFlag = "";
            let param = {
                parentId: this.parentId,
                parentName: this.parentName
            };
            if (row != null && row != "") {
                operateFlag = "update";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(param, row, operateFlag);
                });
            } else {
                operateFlag = "add";
                this.$nextTick(() => {
                    this.$refs.editDlgRef.init(param, "", operateFlag);
                });
            }
        },
        openAuthorizeDlg (index, row) {
            this.authorizeDlgShow = true;
            this.$nextTick(() => {
                this.$refs.authorizeDlgRef.init(index, row, row.id, this.parentId);
            });
        },

        deleteData () {
            let idList = new Array();
            if (this.multipleSelection.length == 0) {
                this.$message.error("请至少选择一条要删除的数据！");
                return false;
            }
            //遍历选中的checkbox数据集合 拿出其中的ids
            for (let i = 0; i < this.multipleSelection.length; i++) {
                idList[i] = "" + this.multipleSelection[i]["id"];
            }
            let param = {
                ids: idList
            };
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                this.loading = true;
                SettingApi.getClass()
                    .deleteStaffById(param)
                    .then(resp => {
                        if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                            this.$message.success("删除成功！");
                            this.loading = false;
                            this.cacheData[this.cur_page] = {};
                            this.refreshData();
                        } else {
                            this.$message.error(resp.data.msg);
                            this.loading = false;
                            return false;
                        }
                    }).catch(err => {
                        this.$message.error(err);
                        this.loading = false;
                        return false;
                    });
            }).catch(() => { });
        },

        //切换每页显示多条
        handleSizeChange (val) {
            this.per_page = val;
            this.cur_page = 1;
            this.loading = true;
            this.getListData(this.parentId);
        },
        // 切换显示第几页
        handleCurrentChange (val) {
            this.cur_page = val;
            this.loading = true;
            this.getListData(this.parentId);
        },
        initDataBySearch () {
            this.cur_page = 1;
            this.getListData(this.parentId);
        },
        checkSelectTable (row, rowIndex) {
            if (row.roleAdmin == true) {
                return false;
            } else {
                return true;
            }
        },
        changeCascade () {
            this.cur_page = 1;
            this.getListData(this.parentId);
        },

        openAuthorizeForAllDlg () {
            let idList = new Array();
            if (this.multipleSelection.length == 0) {
                this.$message.error("请至少选择一个员工！");
                return false;
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
                idList[i] = "" + this.multipleSelection[i]["id"];
            }
            this.authorizeForAllDlgShow = true;
            this.$nextTick(() => {
                this.$refs.authorizeForAllDlgRef.init(idList, this.parentId);
            });
        },

        batchEnableUserStatus (disabled) {
            let idList = new Array();
            if (this.multipleSelection.length == 0) {
                this.$message.error("请至少选择一个员工！");
                return false;
            }
            for (let i = 0; i < this.multipleSelection.length; i++) {
                idList.push(this.multipleSelection[i].id);
            }
            let param = {
                ids: idList,
                status: disabled
            };

            this.loading = true;

            SettingApi.getClass()
                .batchEnableUserStatus(param)
                .then(resp => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        if (disabled == "0") {
                            this.$message.success("用户启用成功！");
                        } else {
                            this.$message.success("用户禁用成功！");
                        }
                        this.getListData(this.parentId);
                        this.cacheData[this.cur_page] = {};
                        this.loading = false;
                    } else {
                        this.$message.error(resp.data.msg);
                        this.loading = false;
                        return false;
                    }
                }).catch(err => {
                    this.loading = false;
                    this.$message.error(err);
                    return false;
                });
        },

        clearChoose () {
            this.cacheData[this.cur_page] = {};
        },
        refreshData () {
            let length = this.multipleSelection.length;
            if (length == null || length == "") {
                length = 1;
            }
            let m = Math.ceil((this.totalCount - length) / this.per_page);
            if (this.cur_page > 1 && this.cur_page > m) {
                this.cur_page = this.cur_page - 1;
            }
            this.onloadGroup();
            this.getListData(this.parentId);
        }
    }
};
</script>

<style lang="stylus" scoped>
#organizationStructure {
    width: 100%;

    .orgLeft {
        width: $dept-left-width;
        margin-left: $content-margin-left;
        float: left;
        background-color: white;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }

    .orgRight {
        margin-top: $content-margin-top;
        background-color: white;
        width: auto;
        margin-right: $content-margin-right;
        margin-left: $dept-left-margin;
        border-radius: $border-radius;
        box-shadow: $box-shadow;
    }

    .custom-tree-node {
        font-size: $default-font;
    }
}

.head-right {
    float: right;
}

.btnColor {
    color: $theme-color;
}

.treeClass >>> .el-tree-node__children {
    overflow: inherit !important;
}

.treeClass >>> .el-tree-node__content {
    width: 100%;
}
</style>